(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('slick-carousel');

	// Slick rounds up, it looks bad, round down before it runs
	/* var fixSubpixelRounding = function () {
		$('.slideshow').each(function () {
			var slideshow = $(this).css('width', 'auto');
			var roundedWidth = Math.floor(slideshow[0].getBoundingClientRect().width);

			slideshow.width(roundedWidth + 'px');
		});
	};

	fixSubpixelRounding();

	$(window).on('resize', fixSubpixelRounding); */

	// Initialize slideshows
	$(window).load(function () {
		$('.slideshow').each(function () {
			var slideshow = $(this);

			slideshow.slick({
				dots: true,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				speed: 200,
				autoplay: false,
				adaptiveHeight: true,
				prevArrow: '<a role="button" class="slick-prev icon-left icon--round icon--round--transparent"></a>',
				nextArrow: '<a role="button" class="slick-next icon-right icon--round icon--round--transparent"></a>'
			});
		});
	});
})();
